import React from "react";
import classNames from "classnames/bind";

import styles from "./NotificationList.module.scss";
const cx = classNames.bind(styles);

const Item = ({ data }) => {
  return (
    <li className={cx("item")}>
      <img src={data.image} alt="..." />
      <p>
        <span>{data.overview}</span>{" "}
        <span className={cx("action")}>{data.action}</span>
      </p>
      <div className={cx("time")}>
        <span>{data.time}</span>
        <span className={cx({ hidden: !data.isFollow })}>Following</span>
      </div>
    </li>
  );
};

export default Item;
